<template>
  <form class="form-login" @submit.prevent="login">
    <div class="form-group row">
      <div class="col-md-12">
        <input
          class="form-control form-username"
          required
          v-model="username"
          type="name"
          placeholder="Username"
        />
      </div>
      <!-- input-group.// -->
    </div>
    <!-- form-group// -->
    <div class="form-group row pb-3">
      <div class="col-md-12">
        <input
          class="form-control form-password"
          required
          v-model="password"
          type="password"
          placeholder="Password"
        />
      </div>
      <!-- input-group.// -->
    </div>
    <!-- form-group// -->
    <div class="form-group row">
      <div class="col-md-8 mx-auto">
        <button type="submit" class="btn btn-primary btn-block">
          Login
        </button>
      </div>
       <a  class="sublink-login" v-on:click = "$parent.viewComponent = 'forgot'" >He olvidado mi contraseña</a>
    </div>
  </form>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    login: function() {
      let username = this.username;
      let password = this.password;
      this.$store
        .dispatch("login", { username, password })
        .then(() => this.$router.push("/mapparams"))
        .catch(err => console.log(err));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/autenticacion/login.vue